export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/pk-pro-cover-b93611e1c55b5d366db9c2e2cc92d8ee.jpg";